var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsightsIconNplms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8125 27.0619C29.8125 31.9894 25.8019 36 20.8744 36H15.1256C10.1981 36 6.1875 31.9894 6.1875 27.0619C6.1875 24.5644 7.245 22.1625 9.08437 20.475L13.3031 16.6106C13.5113 16.4194 13.7812 16.3125 14.0625 16.3125H21.9375C22.2188 16.3125 22.4887 16.4194 22.6969 16.6106L26.9156 20.475C28.755 22.1625 29.8125 24.5644 29.8125 27.0619Z",
    fill: "#6C7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.625C21.4173 32.625 24.1875 29.8548 24.1875 26.4375C24.1875 23.0202 21.4173 20.25 18 20.25C14.5827 20.25 11.8125 23.0202 11.8125 26.4375C11.8125 29.8548 14.5827 32.625 18 32.625Z",
    fill: "#9DA8EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.6875C17.379 28.6875 16.875 28.1835 16.875 27.5625V25.3125C16.875 24.6915 17.379 24.1875 18 24.1875C18.621 24.1875 19.125 24.6915 19.125 25.3125V27.5625C19.125 28.1835 18.621 28.6875 18 28.6875Z",
    fill: "#C8D0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1706 1.31062L23.0456 8.06063C22.9556 8.60063 22.4888 9 21.9375 9H15.1875C14.6363 9 14.1694 8.60063 14.0794 8.06063L12.9544 1.31062C12.8981 0.984375 12.9881 0.6525 13.2019 0.399375C13.4156 0.14625 13.7306 0 14.0625 0H14.9231C16.3125 0 17.6119 0.545625 18.5625 1.485C19.5131 0.545625 20.8125 0 22.2019 0H23.0625C23.3944 0 23.7094 0.14625 23.9231 0.399375C24.1369 0.6525 24.2269 0.984375 24.1706 1.31062Z",
    fill: "#6C7DE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0819 9.88922L24.3563 16.0767C24.1875 17.4942 22.9894 18.563 21.5606 18.563H12.5606C11.1094 18.563 9.675 18.0848 8.51063 17.213L8.06063 16.8755H6.75C6.13125 16.8755 5.625 16.3692 5.625 15.7505V5.62547C5.625 5.00672 6.13125 4.50047 6.75 4.50047H8.47125C9.65813 3.17859 11.3344 2.36297 13.1119 2.26172L13.86 6.75047H22.2919C22.6181 6.75047 22.9331 6.80672 23.2369 6.91922C23.6756 7.07109 24.075 7.33547 24.39 7.69547C24.9244 8.29172 25.1775 9.09609 25.0819 9.88922Z",
    fill: "#9DA8EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 4.5V16.875C7.3125 17.8031 6.55312 18.5625 5.625 18.5625H1.6875C0.759375 18.5625 0 17.8031 0 16.875V4.5C0 3.57188 0.759375 2.8125 1.6875 2.8125H5.625C6.55312 2.8125 7.3125 3.57188 7.3125 4.5Z",
    fill: "#8997EA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsightsIconNplms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/insights_icon_nplms.a1aaab6cfe041bf60015f5f42f254319.svg";